function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomColorField from './CustomColorField';
import '../assets/inputFields.css';
const GoogleMapsAutocomplete = ({
  inputRef,
  val,
  defaultValue,
  required,
  onBlur,
  onChange = () => {},
  placeholder,
  margin = 'normal',
  ...rest
}) => {
  const [errorMessage, setErrorMessage] = useState();
  const {
    t
  } = useTranslation();
  rest.inputProps = {
    requiredstr: required ? 'true' : 'false'
  };
  const onBlurHandler = () => {
    setErrorMessage(null);
    onBlur && onBlur();
  };
  useEffect(() => {
    const validationListener = event => {
      // console.log('EVENT', event);
      event.stopPropagation();
      setErrorMessage(t(event.target.errormsg).replace('[nome]', rest.label).replace('[errormsgparam]', event.target.errormsgparam));
    };
    const node = inputRef && inputRef.current;
    node && node.addEventListener('invalid-data', validationListener);
    return () => {
      node && node.removeEventListener('invalid-data', validationListener);
    };
  }, [inputRef, rest.label, t]);
  if (errorMessage) {
    rest.error = true;
    rest.helperText = errorMessage;
  }
  if (val) {
    rest.value = val;
  }
  if (defaultValue) {
    rest.defaultValue = defaultValue;
  }
  return /*#__PURE__*/React.createElement(CustomColorField, _extends({
    variant: "outlined",
    onBlur: onBlurHandler
  }, rest, {
    inputRef: inputRef,
    margin: margin,
    onChange: onChange,
    placeholder: placeholder
  }));
};
export default GoogleMapsAutocomplete;